import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

interface UserExistsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSwitchToLogin: () => void;
  email?: string;
}

export function UserExistsDialog({
  open,
  onOpenChange,
  onSwitchToLogin,
  email,
}: UserExistsDialogProps) {
  const handleSwitchToLogin = () => {
    onOpenChange(false);
    onSwitchToLogin();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/20">
              <AlertCircle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <DialogTitle className="text-lg">Conta já existe</DialogTitle>
          </div>
        </DialogHeader>
        
        <DialogDescription className="text-sm leading-relaxed">
          {email ? (
            <>
              O e-mail <span className="font-medium text-foreground">{email}</span> já está cadastrado em nosso sistema.
            </>
          ) : (
            "Este e-mail já está cadastrado em nosso sistema."
          )}{" "}
          Por favor, faça login para acessar sua conta ou use um e-mail diferente para criar uma nova conta.
        </DialogDescription>
        
        <DialogFooter className="flex-col-reverse sm:flex-col gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full"
          >
            Usar outro e-mail
          </Button>
          <Button
            onClick={handleSwitchToLogin}
            className="w-full"
          >
            Fazer login
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
